import styled from 'styled-components'

const OkresSprawozdaniaStyle = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto auto;

  .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 184px 76px 184px;
  }

  .secondRow {
    grid-row: 2/3;
    width: 184px;
  }

  .separator {
    font-size: 20px;
    text-align: center;
  }
`
export default OkresSprawozdaniaStyle
